import styled from "@emotion/styled";
import { Box } from "@mui/material";
import theme from "../theme";

export const CenterBoxLayout = styled(Box)`
  max-width: 500px;
  width: 500px;

  ${theme.breakpoints.down("sm")} {
    width: 100%;
  }
`;
